export enum DomainEnum {
  SOE = 'https://saveonenergy.com',
  CHOOSE = 'https://chooseenergy.com',
  TXER = 'https://texaselectricrates.com',
  CTXP = 'https://choosetexaspower.org',
}

export type SiteDomain =
  | 'saveonenergy.com'
  | 'chooseenergy.com'
  | 'texaselectricrates.com'
  | 'choosetexaspower.org'
  | 'new.choosetexaspower.org'
  | 'new.texaselectricrates.com'
